export const subnational = {
  "POL": {
    "PL31": "Lubelskie",
    "PL32": "Podkarpackie",
    "PL33": "Swietokrzyskie",
    "PL34": "Podlaskie",
    "PL41": "Wielkopolskie",
    "PL42": "Zachodniopomorskie",
    "PL43": "Lubuskie",
    "PL51": "Dolnoslaskie",
    "PL52": "Opolskie",
    "PL11": "Lódzkie",
    "PL61": "Kujawsko-Pomorskie",
    "PL62": "Warminsko-Mazurskie",
    "PL12": "Mazowieckie",
    "PL63": "Pomorskie",
    "PL21": "Malopolskie",
    "PL22": "Slaskie"
  },
  "MEX": {
    "mex_2": "Baja California",
    "mex_3": "Baja California Sur",
    "mex_5": "Coahuila",
    "mex_8": "Chihuahua",
    "mex_10": "Durango",
    "mex_25": "Sinaloa",
    "mex_26": "Sonora",
    "mex_32": "Zacatecas",
    "mex_19": "Nuevo León",
    "mex_24": "San Luis Potosí",
    "mex_28": "Tamaulipas",
    "mex_1": "Aguascalientes",
    "mex_6": "Colima",
    "mex_14": "Jalisco",
    "mex_16": "Michoacán",
    "mex_18": "Nayarit",
    "mex_4": "Campeche",
    "mex_20": "Oaxaca",
    "mex_21": "Puebla",
    "mex_27": "Tabasco",
    "mex_29": "Tlaxcala",
    "mex_9": "Distrito Federal",
    "mex_11": "Guanajuato",
    "mex_12": "Guerrero",
    "mex_13": "Hidalgo",
    "mex_15": "México",
    "mex_17": "Morelos",
    "mex_22": "Querétaro",
    "mex_30": "Veracruz",
    "mex_7": "Chiapas",
    "mex_23": "Quintana Roo",
    "mex_31": "Yucatán"
  },
  "DEU": {
    "DE50": "Bremen",
    "DE60": "Hamburg",
    "DE71": "Darmstadt/Frankfurt",
    "DE72": "Gießen",
    "DE73": "Kassel",
    "DE80": "Mecklenburg-Vorpommern",
    "DE91": "Braunschweig",
    "DE92": "Hannover",
    "DE93": "Lüneburg",
    "DE94": "Weser-Ems",
    "DE11": "Stuttgart",
    "DE12": "Karlsruhe",
    "DE13": "Freiburg",
    "DE14": "Tübingen",
    "DE21": "Oberbayern",
    "DE22": "Niederbayern",
    "DE23": "Oberpfalz",
    "DE24": "Oberfranken",
    "DE25": "Mittelfranken",
    "DE26": "Unterfranken",
    "DE27": "Schwaben",
    "DE30": "Berlin",
    "DE40": "Brandenburg",
    "DEA1": "Düsseldorf",
    "DEA2": "Köln",
    "DEA3": "Münster",
    "DEA4": "Detmold",
    "DEA5": "Arnsberg",
    "DEB1": "Koblenz",
    "DEB2": "Trier",
    "DEB3": "Rheinhessen-Pfalz",
    "DEC0": "Saarland",
    "DED2": "Dresden",
    "DED4": "Chemnitz",
    "DED5": "Leipzig",
    "DEE0": "Sachsen-Anhalt",
    "DEF0": "Schleswig-Holstein",
    "DEG0": "Thüringen"
  },
  "FRA": {
    "FR30": "Nord - Pas-de-Calais",
    "FR41": "Lorraine",
    "FR42": "Alsace",
    "FR43": "Franche-Comté",
    "FR51": "Pays de la Loire",
    "FR10": "Île de France",
    "FR21": "Champagne-Ardenne",
    "FR22": "Picardie",
    "FR23": "Haute-Normandie",
    "FR24": "Centre",
    "FR25": "Basse-Normandie",
    "FR26": "Bourgogne",
    "FR52": "Bretagne",
    "FR61": "Aquitaine",
    "FR62": "Midi-Pyrénées",
    "FR63": "Limousin",
    "FR71": "Rhône-Alpes",
    "FR72": "Auvergne",
    "FR81": "Languedoc-Roussillon",
    "FR82": "Provence-Alpes-Côte d'Azur",
    "FR53": "Poitou-Charentes",
    "FR83": "Corse"
  },
  "GBR": {
    "UKC1": "Tees Valley and Durham",
    "UKC2": "Northumberland and Tyne and Wear",
    "UKD1": "Cumbria",
    "UKD3": "Greater Manchester",
    "UKD4": "Lancashire",
    "UKD6": "Cheshire",
    "UKD7": "Merseyside",
    "UKE1": "East Yorkshire and Northern Lincolnshire",
    "UKE2": "North Yorkshire",
    "UKE3": "South Yorkshire",
    "UKM6": "Highlands and Islands",
    "UKK1": "Gloucestershire, Wiltshire and Bristol/Bath area",
    "UKK2": "Dorset and Somerset",
    "UKK3": "Cornwall and Isles of Scilly",
    "UKK4": "Devon",
    "UKL1": "West Wales and The Valleys",
    "UKL2": "East Wales",
    "UKM5": "North Eastern Scotland",
    "UKM7": "Eastern Scotland",
    "UKM8": "West Central Scotland",
    "UKM9": "Southern Scotland",
    "UKN0": "Northern Ireland",
    "UKE4": "West Yorkshire",
    "UKF1": "Derbyshire and Nottinghamshire",
    "UKF2": "Leicestershire, Rutland and Northamptonshire",
    "UKF3": "Lincolnshire",
    "UKG1": "Herefordshire, Worcestershire and Warwickshire",
    "UKG2": "Shropshire and Staffordshire",
    "UKG3": "West Midlands",
    "UKH1": "East Anglia",
    "UKH2": "Bedfordshire and Hertfordshire",
    "UKH3": "Essex",
    "UKI3": "Inner London - West",
    "UKI4": "Inner London - East",
    "UKI5": "Outer London - East and North East",
    "UKI6": "Outer London - South",
    "UKI7": "Outer London - West and North West",
    "UKJ1": "Berkshire, Buckinghamshire and Oxfordshire",
    "UKJ2": "Surrey, East and West Sussex",
    "UKJ3": "Hampshire and Isle of Wight",
    "UKJ4": "Kent"
  },
  "ITA": {
    "ITC1": "Piemonte",
    "ITC2": "Valle d'Aosta/Vallée d'Aoste",
    "ITC3": "Liguria",
    "ITG2": "Sardegna",
    "ITH1": "Provincia Autonoma di Bolzano/Bozen",
    "ITH2": "Provincia Autonoma di Trento",
    "ITH3": "Veneto",
    "ITH4": "Friuli-Venezia Giulia",
    "ITH5": "Emilia-Romagna",
    "ITI1": "Toscana",
    "ITI2": "Umbria",
    "ITI3": "Marche",
    "ITI4": "Lazio",
    "ITC4": "Lombardia",
    "ITF1": "Abruzzo",
    "ITF2": "Molise",
    "ITF3": "Campania",
    "ITF4": "Puglia",
    "ITF5": "Basilicata",
    "ITF6": "Calabria",
    "ITG1": "Sicilia"
  },
  "ESP": {
    "ES43": "Extremadura",
    "ES51": "Cataluña",
    "ES52": "Comunidad Valenciana",
    "ES53": "Illes Balears",
    "ES61": "Andalucía",
    "ES62": "Región de Murcia",
    "ES63": "Ciudad Autónoma de Ceuta",
    "ES64": "Ciudad Autónoma de Melilla",
    "ES70": "Canarias",
    "ES11": "Galicia",
    "ES12": "Principado de Asturias",
    "ES13": "Cantabria",
    "ES21": "País Vasco",
    "ES22": "Comunidad Foral de Navarra",
    "ES23": "La Rioja",
    "ES24": "Aragón",
    "ES30": "Comunidad de Madrid",
    "ES41": "Castilla y León",
    "ES42": "Castilla-La Mancha"
  },
  "NLD": {
    "NL11": "Groningen",
    "NL12": "Friesland (NL)",
    "NL13": "Drenthe",
    "NL21": "Overijssel",
    "NL22": "Gelderland",
    "NL23": "Flevoland",
    "NL31": "Utrecht",
    "NL32": "Noord-Holland",
    "NL33": "Zuid-Holland",
    "NL34": "Zeeland",
    "NL41": "Noord-Brabant",
    "NL42": "Limburg (NL)"
  },
  "BEL": {
    "BE23": "Prov. Oost-Vlaanderen",
    "BE24": "Prov. Vlaams-Brabant",
    "BE25": "Prov. West-Vlaanderen",
    "BE31": "Prov. Brabant Wallon",
    "BE32": "Prov. Hainaut",
    "BE33": "Prov. Liège",
    "BE34": "Prov. Luxembourg (BE)",
    "BE35": "Prov. Namur",
    "BE10": "Bruxelles Capitale",
    "BE21": "Prov. Antwerpen",
    "BE22": "Prov. Limburg (BE)"
  },
  "SWE": {
    "SE11": "Stockholm",
    "SE12": "Östra Mellansverige",
    "SE21": "Småland med öarna",
    "SE22": "Sydsverige",
    "SE23": "Västsverige",
    "SE31": "Norra Mellansverige",
    "SE32": "Mellersta Norrland",
    "SE33": "Övre Norrland"
  },
  "AUT": {
    "AT11": "Burgenland",
    "AT12": "Niederosterreich",
    "AT13": "Wien",
    "AT21": "Karnten",
    "AT22": "Steiermark",
    "AT31": "Oberosterreich",
    "AT32": "Salzburg",
    "AT33": "Tirol",
    "AT34": "Vorarlberg"
  },
  "CZE": {
    "CZ07": "Střední Morava",
    "CZ08": "Moravskoslezsko",
    "CZ01": "Praha",
    "CZ02": "Střední Čechy",
    "CZ03": "Jihozápad",
    "CZ04": "Severozápad",
    "CZ05": "Severovýchod",
    "CZ06": "Jihovýchod"
  },
  "DNK": {
    "DK01": "Hovedstaden",
    "DK02": "Sjælland",
    "DK03": "Syddanmark",
    "DK04": "Midtjylland",
    "DK05": "Nordjylland"
  },
  "FIN": {
    "FI19": "Länsi-Suomi",
    "FI1B": "Helsinki-Uusimaa",
    "FI1C": "Etelä-Suomi",
    "FI1D": "Pohjois- ja Itä-Suomi"
  },
  "GRC": {
    "EL53": "Δυτική Μακεδονία",
    "EL54": "Ήπειρος",
    "EL61": "Θεσσαλία",
    "EL62": "Ιόνια Νησιά",
    "EL63": "Δυτική Ελλάδα",
    "EL64": "Στερεά Ελλάδα",
    "EL65": "Πελοπόννησος",
    "EL30": "Aττική",
    "EL41": "Βόρειο Αιγαίο",
    "EL42": "Νότιο Αιγαίο",
    "EL43": "Κρήτη",
    "EL51": "Aνατολική Μακεδονία, Θράκη",
    "EL52": "Κεντρική Μακεδονία"
  },
  "HUN": {
    "HU10": "Közép-Magyarország",
    "HU21": "Közép-Dunántúl",
    "HU22": "Nyugat-Dunántúl",
    "HU23": "Dél-Dunántúl",
    "HU31": "Észak-Magyarország",
    "HU32": "Észak-Alföld",
    "HU33": "Dél-Alföld"
  },
  "SVK": {
    "SK01": "Bratislavský kraj",
    "SK02": "Západné Slovensko",
    "SK03": "Stredné Slovensko",
    "SK04": "Východné Slovensko"
  },
  "IRL": {
    "IE01": "Border, Midland and Western",
    "IE02": "Southern and Eastern"
  }
};